import $api from '@/http/api'
import store from '@/store'
import { getBusinessType } from '@/constant'

async function getUserRegional () {
  // 南京银行需要做配置

  let code
  if (store.state.regional === '') {
    const { data } = await $api.user.getUserRegional()
    store.commit('setRegional', data.code)
    code = data.code
  } else {
    code = store.state.regional
  }

  // 需要后续 制定场景，需要自动判断地域， 进行手机或邮箱登录
  // 如果不需要，则需要选择支持那种 比如默认邮箱或者默认手机号
  const type = getBusinessType().isSupportRegion ? code === 1 ? 'email' : 'phone' : 'phone'

  return {
    code,
    type,
  }
}

export {getUserRegional }
